(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["tab-content"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.cf-dp-faq-section .faq-item').forEach(item => {
  const iconSpan = item.querySelector('.plus-icon');
  const plusIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" height="25" width="24"><path stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="#121212" d="M12 8.87207V16.8721M8 12.8721H16M22 12.8721C22 18.3949 17.5228 22.8721 12 22.8721C6.47715 22.8721 2 18.3949 2 12.8721C2 7.34922 6.47715 2.87207 12 2.87207C17.5228 2.87207 22 7.34922 22 12.8721Z"></path></svg>`;
  const minusIcon = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 25" height="25" width="24"><path stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="#121212" d="M8 12.8721H16M22 12.8721C22 18.3949 17.5228 22.8721 12 22.8721C6.47715 22.8721 2 18.3949 2 12.8721C2 7.34922 6.47715 2.87207 12 2.87207C17.5228 2.87207 22 7.34922 22 12.8721Z"></path></svg>`;

  item.addEventListener('click', () => {
    const isActive = item.classList.contains('active');

    document.querySelectorAll('.cf-dp-faq-section .faq-item').forEach(i => {
      i.classList.remove('active');
      i.querySelector('.plus-icon').innerHTML = plusIcon;
    });

    if (!isActive) {
      item.classList.add('active');
      iconSpan.innerHTML = minusIcon;
    } else {
      iconSpan.innerHTML = plusIcon;
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
